import { render, staticRenderFns } from "./RandoxKitOrder.vue?vue&type=template&id=3d991fc9"
import script from "./RandoxKitOrder.vue?vue&type=script&lang=js"
export * from "./RandoxKitOrder.vue?vue&type=script&lang=js"
import style0 from "./RandoxKitOrder.vue?vue&type=style&index=0&id=3d991fc9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports